import { useEffect, useRef, useState } from "react";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ImageUpload } from "../ImageUpload";

export const LocationImages = ({
    editMode,
    isBanner,
    images,
    refreshList
}) => {

    const [imageFile, setImageFile] = useState([]);
    const prevEditMode = useRef(editMode);

    useEffect(() => {
        const getImages = (id) => {
            if (images.length !== 0)
                return images.filter((type) => type.image_type === id);
            else return [];
        };

        if (isBanner)
            setImageFile(getImages(2)); // banner
        else
            setImageFile(getImages(1)); // logo
    }, [images]);

	useEffect(() => {
        if (prevEditMode.current && !editMode) {
            refreshList();
        }
        prevEditMode.current = editMode;
    }, [editMode]);

    return (
        <div
            style={{ width: "100%", minWidth: "160px", textAlign: "end" }}
        >
            {!editMode && imageFile.length > 0 && imageFile[0]?.image && (
                <img
                    style={{
                        width: "50%",
                        objectFit: "contain",
                        borderRadius: "4px"
                    }}
                    src={imageFile[0].image}
                />
            )}
            
            {!editMode && imageFile.length === 0 && (
                <div
                    style={{
                        height: "70px",
                        width: "70px",
                        marginRight: "30px",
                        resizeMode: "contain",
                        borderRadius: "4px",
                        backgroundColor: ColorScheme.black
                    }}
                />
            )}

            {editMode && (
                <ImageUpload
                    imageType={isBanner ? "banner" : "logo"}
                    oldImage={imageFile.length > 0 ? imageFile[0] : null}
                    refreshList={refreshList}
                />
            )}
        </div>
    );
};